module.exports = __webpack_public_path__ + "img/20180414170003.ac0bc33c.jpg";